<template>
    <router-link tag="div" class="icon-card" :to="link" v-if="type == 'router'">
        <div class="icon-img">
            <img :src="image" alt="icon-image">
        </div>
        <div class="icon-name">{{ title }} <small>{{ subTitle }}</small></div>
    </router-link>
    <a class="icon-card" :href="link" target="_blank" v-else>
        <div class="icon-img">
            <img :src="image" alt="icon-image">
        </div>
        <div class="icon-name">{{ title }} <small>{{ subTitle }}</small></div>
    </a>
</template>

<script>
export default {
    name: 'IconCard',
    props: {
        link: String,
        image: String,
        title: String,
        subTitle: String,
        type: {
            type: String,
            default: 'link'
        }
    }
}
</script>

<style lang="scss">
.icon-card{
    display: flex;
    cursor: pointer;
    text-align: center;
    margin-bottom: 50px;
    align-items: center;
    flex-direction: column;

    &:hover{
        text-decoration: none;
    }

    &:hover > .icon-img{
        background-color: rgba(255, 255, 255, 0.15);
    }

    &:hover > .icon-name{
        margin-right: 10px;
    }

    &:hover > .icon-name small{
        margin-left: 25px;
    }

    .icon-img{
        display: flex;
        align-items: center;
        width: 150px;
        height: 150px;
        padding: 10px 20px;
        border-radius: 20px;
        background-color: rgba(255, 255, 255, 0.10);
        transition: all ease-in-out 0.2s;
        
        img{
            width: 85%;
            height: auto;
            margin: 0 auto;
        }
    }

    .icon-name{
        color: #fff;
        margin-top: 5px;
        font-weight: bold;
        font-size: 1.25rem;
        transition: all ease-in-out 0.2s;

        small{
            font-size: 0.75rem;
            display: block;
            margin-top: -5px;
            transition: all ease-in-out 0.2s;
        }
    }
}
</style>